<template>
  <div class="masonry-gallery">
    <div class="masonry">
      <div
        class="card"
        v-for="(photo, i) in photos"
        :key="i"
        @click="open(i)"
      >
        <img :src="photo.src" :alt="photo.alt" />
      </div>
    </div>

    <transition name="fade">
      <div class="lightbox" v-if="active !== null" @click.self="active = null">
        <div class="lb-inner">
          <button class="lb-close" @click="active = null">✕</button>
          <button class="lb-prev" @click="active--" :disabled="active === 0">‹</button>
          <img :src="photos[active].src" :alt="photos[active].alt" />
          <button class="lb-next" @click="active++" :disabled="active === photos.length - 1">›</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'MasonryGallery',
  props: {
    photos: {
      type: Array,
      required: true,
      // Expected shape: [{ src: String, alt: String }]
    }
  },
  data() {
    return {
      active: null
    }
  },
  methods: {
    open(i) {
      this.active = i
    },
    onKeydown(e) {
      if (this.active === null) return
      if (e.key === 'Escape') this.active = null
      if (e.key === 'ArrowLeft' && this.active > 0) this.active--
      if (e.key === 'ArrowRight' && this.active < this.photos.length - 1) this.active++
    }
  },
  mounted() {
    window.addEventListener('keydown', this.onKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeydown)
  }
}
</script>

<style scoped>
.masonry-gallery {
  padding: 12px;
}

.masonry {
  columns: 3 240px;
  column-gap: 12px;
}

.card {
  break-inside: avoid;
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}

.card img {
  width: 100%;
  display: block;
  transition: transform 0.4s ease;
}

.card:hover img {
  transform: scale(1.03);
}

/* Lightbox */
.lightbox {
  position: fixed;
  inset: 0;
  background: rgba(5, 10, 20, 0.96);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.lb-inner {
  position: relative;
  max-width: 960px;
  width: 100%;
}

.lb-inner img {
  width: 100%;
  border-radius: 10px;
  display: block;
}

.lb-close {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: #fff;
  font-size: 1.6rem;
  cursor: pointer;
  opacity: 0.7;
}

.lb-close:hover { opacity: 1; }

.lb-prev,
.lb-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #fff;
  font-size: 1.4rem;
  padding: 12px 16px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.2s;
}

.lb-prev:hover,
.lb-next:hover { background: rgba(255, 255, 255, 0.25); }

.lb-prev { left: -56px; }
.lb-next { right: -56px; }

.lb-prev:disabled,
.lb-next:disabled { opacity: 0.2; cursor: default; }

.fade-enter-active,
.fade-leave-active { transition: opacity 0.25s; }
.fade-enter,
.fade-leave-to { opacity: 0; }
</style>
